<template>
    <div v-if="rows.length" class="chat-table-wrapper">
        <!-- <div v-if="table.header" class="chat-table-title">{{ table.header }}</div> -->

        <div class="chat-table-scroll">
            <table class="chat-table">
                <thead>
                    <tr>
                        <th v-for="column in columns" :key="column">{{ column }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(row, rowIndex) in visibleRows" :key="rowIndex">
                        <td v-for="column in columns" :key="column">{{ row[column] }}</td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div v-if="totalPages > 1 || downloadFileName" class="chat-table-pagination">
            <div class="chat-table-range">
                <template v-if="totalPages > 1">{{ rangeStart }}-{{ rangeEnd }} of {{ rows.length }}</template>
                <template v-else>{{ rows.length }} {{ rows.length === 1 ? "row" : "rows" }}</template>
            </div>
            <q-space />
            <template v-if="totalPages > 1">
                <q-btn flat dense round icon="chevron_left" size="xs" :disable="page === 1" @click="page -= 1" />
                <div class="chat-table-page">{{ page }} / {{ totalPages }}</div>
                <q-btn flat dense round icon="chevron_right" size="xs" :disable="page === totalPages" @click="page += 1" />
            </template>
            <q-btn v-if="downloadFileName" flat dense round icon="download" size="xs" color="grey-8" class="q-ml-xs" @click="downloadAsCsv">
                <q-tooltip anchor="top middle" self="bottom middle" :offset="[0, 6]" class="bg-grey-9" style="font-size: 10px;">Download as CSV</q-tooltip>
            </q-btn>
        </div>
    </div>
</template>

<script>
import { downloadCsv } from "@/chatDownloads.js";

export default {
    name: "ChatTable",

    props: {
        table: {
            type: Object,
            default: () => ({}),
        },
        rowsPerPage: {
            type: Number,
            default: 5,
        },
        // CSV file name without the extension; the download button is hidden when empty.
        downloadFileName: {
            type: String,
            default: "",
        },
    },

    data() {
        return {
            page: 1,
        };
    },

    computed: {
        rows() {
            return Array.isArray(this.table?.data) ? this.table.data : [];
        },
        columns() {
            const columns = [];
            this.rows.forEach((row) => {
                Object.keys(row || {}).forEach((key) => {
                    if (!columns.includes(key)) {
                        columns.push(key);
                    }
                });
            });
            return columns;
        },
        totalPages() {
            return Math.max(1, Math.ceil(this.rows.length / this.rowsPerPage));
        },
        rangeStart() {
            return (this.page - 1) * this.rowsPerPage + 1;
        },
        rangeEnd() {
            return Math.min(this.page * this.rowsPerPage, this.rows.length);
        },
        visibleRows() {
            return this.rows.slice(this.rangeStart - 1, this.rangeEnd);
        },
    },

    watch: {
        table() {
            this.page = 1;
        },
        totalPages(pages) {
            if (this.page > pages) {
                this.page = pages;
            }
        },
    },

    methods: {
        downloadAsCsv() {
            downloadCsv(this.columns, this.rows, this.downloadFileName);
        },
    },
};
</script>

<style scoped>
.chat-table-wrapper {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    margin-top: 8px;
    background: #ffffff;
    border: 1px solid #ffd3c0;
    border-radius: 6px;
    overflow: hidden;
}

.chat-table-title {
    padding: 6px 8px;
    border-bottom: 1px solid #ffd3c0;
    background: #fff6f0;
    color: #b33700;
    font-size: 9px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
}

.chat-table-scroll {
    width: 100%;
    max-width: 100%;
    min-width: 0;
    overflow-x: auto;
}

.chat-table-scroll::-webkit-scrollbar {
    height: 6px;
}

.chat-table-scroll::-webkit-scrollbar-thumb {
    border-radius: 7px;
    background: #e5e8ed;
}

.chat-table {
    width: 100%;
    min-width: max-content;
    border-collapse: collapse;
    font-size: 10px;
    color: #414141;
}

.chat-table th {
    padding: 6px 8px;
    border-bottom: 1px solid #dedede;
    background: #f7f7f7;
    color: #5f5f5f;
    font-weight: 700;
    text-align: left;
    white-space: nowrap;
}

.chat-table td {
    padding: 5px 8px;
    border-bottom: 1px solid #f0f0f0;
    white-space: nowrap;
}

.chat-table tbody tr:last-child td {
    border-bottom: none;
}

.chat-table tbody tr:hover td {
    background: #fff6f0;
}

.chat-table-pagination {
    display: flex;
    align-items: center;
    padding: 3px 6px;
    border-top: 1px solid #f0f0f0;
    background: #fbfbfb;
    color: #8d8d8d;
    font-size: 9px;
}

.chat-table-page {
    padding: 0 4px;
    color: #5f5f5f;
    font-weight: 600;
    white-space: nowrap;
}
</style>
